import { Outlet, Link } from "react-router-dom";
import CartDrawer from "./CartDrawer";
import StoreHeader from "./StoreHeader";
import FloatingChat from "./FloatingChat";
import AcceptedPayments from "./AcceptedPayments";

export default function StoreLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-white text-zinc-900 overflow-x-hidden">
      <StoreHeader />

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="border-t border-zinc-100 mt-24 bg-zinc-50">
        <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-3 gap-8">
          <div>
            <div className="text-xl font-black tracking-tighter" style={{ fontFamily: "Outfit" }}>
              SMIBHA <span className="italic font-light luxe-text mx-1.5">Luxe</span> CANDLES
            </div>
            <p className="text-xs text-zinc-500 mt-3 leading-relaxed">
              Hand-poured luxury candles in small batches from our Ontario studio. Slow living, in
              the form of a flame.
            </p>
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-[0.3em] font-bold mb-3">Help</div>
            <ul className="text-xs text-zinc-600 space-y-2">
              <li><Link to="/shipping-returns" data-testid="footer-shipping">Shipping, Returns &amp; Refunds</Link></li>
              <li><Link to="/faq" data-testid="footer-faq">FAQ</Link></li>
              <li><Link to="/contact" data-testid="footer-contact">Contact</Link></li>
            </ul>
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-[0.3em] font-bold mb-3">Legal</div>
            <ul className="text-xs text-zinc-600 space-y-2">
              <li><Link to="/terms" data-testid="footer-terms">Terms of Service</Link></li>
              <li><Link to="/privacy" data-testid="footer-privacy">Privacy Policy</Link></li>
              <li>
                <Link to="/admin" className="text-zinc-400 hover:text-zinc-900">
                  Admin
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-zinc-200">
          <div className="max-w-7xl mx-auto px-6 py-8">
            <AcceptedPayments />
          </div>
        </div>
        <div className="border-t border-zinc-200">
          <div className="max-w-7xl mx-auto px-6 py-6 pb-24 sm:pb-6 text-[10px] uppercase tracking-[0.2em] text-zinc-400 flex flex-col md:flex-row gap-2 justify-between items-center">
            <span>© {new Date().getFullYear()} Smibha Luxe Candles. All rights reserved.</span>
            <span>Powered by secure Stripe checkout</span>
          </div>
        </div>
      </footer>

      <CartDrawer />
      <FloatingChat />
    </div>
  );
}
